import { useMemo } from 'react';
import { usePermissions } from '@/shared/hooks/usePermissions';
import { InspectionItemStatus } from '@/shared/enums/InspectionStatus';

export function useLaudoPermissions(itemStatus: InspectionItemStatus | undefined) {
  const { isInspectorUser, hasAnyProviderRole, hasAnyBankRole } = usePermissions();

  const isInspector = isInspectorUser();
  const isProvider = hasAnyProviderRole();
  const isBank = hasAnyBankRole();

  const reviewerType: 'Provider' | 'Bank' = isProvider ? 'Provider' : isBank ? 'Bank' : 'Provider';

  const isAutomaticStatusFlow = useMemo(() => (
    itemStatus === InspectionItemStatus.ProcessandoScraping ||
    itemStatus === InspectionItemStatus.AguardandoAnaliseIA ||
    itemStatus === InspectionItemStatus.ProcessandoAnaliseIA ||
    itemStatus === InspectionItemStatus.LaudoAutomaticoGerado ||
    itemStatus === InspectionItemStatus.ScrapingFalhou ||
    itemStatus === InspectionItemStatus.AnaliseIAFalhou
  ), [itemStatus]);

  const isAutomaticReportFlow = itemStatus === InspectionItemStatus.AguardandoPreenchimentoPrestadora;
  // Laudo automático (AVM) preenchido pelo próprio banco: ao transmitir, já fica aceito
  const isAwaitingBankFill = itemStatus === InspectionItemStatus.AguardandoPreenchimentoBanco;
  const isAwaitingProviderReview = itemStatus === InspectionItemStatus.AguardandoRevisaoPrestadora;
  const isRejectedByProvider = itemStatus === InspectionItemStatus.LaudoNegadoPorPrestadora;
  const isAwaitingBankReview = itemStatus === InspectionItemStatus.AguardandoRevisaoBanco;
  const isRejectedByBank = itemStatus === InspectionItemStatus.LaudoNegadoPorBanco;
  const isBankInspectorCorrecting = itemStatus === InspectionItemStatus.CorrecaoPeloInspetorBanco;
  const isApprovedByBank = itemStatus === InspectionItemStatus.LaudoAceitoPeloBanco;
  const isAwaitingCalculations = itemStatus === InspectionItemStatus.AguardandoCalculosPrestadora;
  const isDevolvidoAposAceite = itemStatus === InspectionItemStatus.DevolvidoPeloBancoAposAceite;

  const isDevolvidoPelaPrestadora = itemStatus === InspectionItemStatus.DevolvidoPelaPrestadora;
  const inspectorCanCreateOrEdit = isRejectedByProvider || isBankInspectorCorrecting;
  const providerCanCorrect = isRejectedByBank || isDevolvidoAposAceite;
  const isUnderReview = isAwaitingProviderReview || isAwaitingBankReview || isApprovedByBank;

  return {
    isInspector,
    isProvider,
    isBank,
    reviewerType,
    isAutomaticStatusFlow,
    isAutomaticReportFlow,
    isAwaitingBankFill,
    isAwaitingProviderReview,
    isRejectedByProvider,
    isAwaitingBankReview,
    isRejectedByBank,
    isBankInspectorCorrecting,
    isApprovedByBank,
    isAwaitingCalculations,
    isDevolvidoPelaPrestadora,
    inspectorCanCreateOrEdit,
    providerCanCorrect,
    isUnderReview,
  };
}
